import { FormikHelpers, useFormik } from "formik";
import TextInput from "../components/basicComponents/text-input";
import TextArea from "../components/basicComponents/text-area";
import Container from "../components/basicComponents/container";
import * as Icons from "../assets/SVGs/index";
import Button from "../components/basicComponents/button";
import { CatalogDataProps, CatalogComponentProps } from "../types/public";
import ToggleSwitch from "./basicComponents/switch-box";
// import { CatalogImageUploader } from "./basicComponents/CatalogImageUploader";
import { catalogValidationSchema } from "../validation/catalog";
import { OrientationRadio } from "./Orientation ";
import ImageUpload from "./basicComponents/image-upload";

export default function CatalogComponent({
  handleSubmit,
  formData,
  // currentUserId,
  loading,
}: CatalogComponentProps) {
  const formik = useFormik<CatalogDataProps>({
    initialValues: formData,
    enableReinitialize: true,
    validationSchema: catalogValidationSchema,
    onSubmit: async (
      values,
      { setSubmitting, resetForm }: FormikHelpers<CatalogDataProps>
    ) => {
      console.log("SUBMIT VALUES 👉", values);
      try {
        console.log("SUBMIT VALUES 👉", values);
        const result = await handleSubmit(values);
        if (result) {
          resetForm();
          localStorage.removeItem("articleImageBase64");
        }
      } catch (error) {
        console.error("Error during submit:", error);
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <div className="flex flex-col items-center w-full">
      <Container header="ثبت کاتالوگ  ">
        <form className="w-full" onSubmit={formik.handleSubmit}>
          <div className="flex flex-col md:flex-row gap-2">
            <div className="mb-5 mt-5 md:w-[66%] w-full">
              <TextInput
                label="عنوان کاتالوگ"
                name="title"
                value={formik.values.title}
                placeholder="عنوان کاتالوگ"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                RightIcon={<Icons.TitleIcon className="w-5 h-5" />}
                helperText={
                  formik.touched.title && formik.errors.title
                    ? formik.errors.title
                    : undefined
                }
              />
            </div>

            <div className="mb-5 mt-5 md:w-[66%] w-full">
              <TextInput
                label="طراحی شده توسط"
                name="designer"
                value={formik.values.designer}
                placeholder="طراحی شده توسط "
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                RightIcon={<Icons.AuthorIcon className="w-5 h-5" />}
                helperText={
                  formik.touched.designer && formik.errors.designer
                    ? formik.errors.designer
                    : undefined
                }
              />
            </div>
            <div className="mb-5 mt-5 md:w-[33.3%] w-full mx-auto">
              <div className="md:w-[14.3%] w-full">
                <ToggleSwitch
                  className="m-0"
                  label="وضعیت انتشار"
                  checked={formik.values.is_active ?? false}
                  onChange={() => {
                    formik.setFieldValue("is_active", !formik.values.is_active);
                  }}
                />
              </div>
            </div>
            <OrientationRadio
              value={formik.values.type}
              onChange={(val) => formik.setFieldValue("type", val)}
            />

            {formik.touched.type && formik.errors.type && (
              <p className="text-xs text-red-500 mt-1">{formik.errors.type}</p>
            )}
          </div>

          <TextArea
            className="mt-3"
            name="description"
            value={formik.values.description}
            placeholder="توضیحات "
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            rows={4}
            error={
              formik.touched.description && formik.errors.description
                ? formik.errors.description
                : undefined
            }
          />
          <div className="md:w-[33.3%] w-full">
            <ImageUpload
              name="index_picture"
              onImageChange={(file) => {
                if (file) {
                  const reader = new FileReader();
                  reader.onloadend = () => {
                    const base64String = reader.result as string;
                    formik.setFieldValue("catalog", base64String);
                    localStorage.setItem("articleImageBase64", base64String);
                  };
                  reader.readAsDataURL(file);
                } else {
                  formik.setFieldValue("catalog", "");
                  localStorage.removeItem("articleImageBase64");
                }
              }}
              onBlur={formik.handleBlur}
              storageKey="articleImageBase64"
              defaultImage={formik.values.catalog || ""}
              helperText={
                formik.touched.catalog && formik.errors.catalog
                  ? formik.errors.catalog
                  : undefined
              }
            />
          </div>

          <div className="flex justify-end">
            <Button
              disabled={loading}
              type="submit"
              title={loading ? "...انتظار" : "ثبت"}
              variant="success"
              bgColor="#9EE1D1"
              borderColor="#00B087"
              color="#00B087"
            />
          </div>
        </form>
      </Container>
    </div>
  );
}
